import { getSessionStoragePrefs, setSessionStoragePrefs } from "./Storage";
export var API_KEY = window.API_KEY;
export var VISITOR_ID = window.VISITOR_ID;
export var DOMAIN_ID = window.DOMAIN_ID;
export var SERVER_REQ_HOST_PATH = window.SERVER_HOST_DOMAIN_URL || "https://app.engagebay.com/";
export var PARENT_WINDOW = window.parent;
export var PARENT_WINDOW_LIVECHAT_REF = PARENT_WINDOW
    ? PARENT_WINDOW.EngageBay_Livechat
    : undefined;
export var CHAT_PREFS = PARENT_WINDOW_LIVECHAT_REF
    ? PARENT_WINDOW_LIVECHAT_REF.ref.settings
    : undefined;
export var NEW_SESSION_URL_PATH = "chat/api/widget/new-session1/" + VISITOR_ID;
export var CONNECT_TO_AGENT_URL_PATH = "chat/api/widget/connect-to-agent/";
export var TICKETS_FETCH_URL = "jsapi/rest/get-tickets/" + VISITOR_ID;
export var TICKET_FETCH_URL = "jsapi/rest/ticket/" + VISITOR_ID;
export var USERS_FETCH_URL = "jsapi/rest/group/users/";
export var USER_FETCH_URL = "jsapi/rest/user/";
export var TICKET_CREATE_URL = "jsapi/rest/create-ticket/" + VISITOR_ID;
export var NOTE_URL = "jsapi/rest/ticket-notes/" + VISITOR_ID;
export var LAST_NOTE_URL = "jsapi/rest/last-note/";
export var MESSAGE_URL_PATH = "chat/api/widget/message/" + VISITOR_ID;
export var KB_COLLECTION_URL_PATH = "jsapi/rest/hc/collections";
export var KB_COLLECTION_URL_PATH_BY_ID = "jsapi/rest/hc/collection/";
export var KB_COLLECTION_CHILDREN_BY_ID = "jsapi/rest/hc/collections";
export var KB_ARTICLE_GET_PATH = "jsapi/rest/help-center/article";
export var KB_ARTICLE_URL_PATH = "jsapi/rest/hc/article/";
export var KB_SEARCH_URL_PATH = "jsapi/rest/hc/search";
export var KB_SEARCH_URL_PATH_V2 = "jsapi/rest/hc/v2/search";
export var GPT_MESSAGE_SCORE_UPDATE_URL_PATH = "chat/api/widget/submit-gpt-message-feedback";
export var BOT_FETCH_URL_PATH = "";
var REQUEST_PREFIX_PATH = "chat/api/";
export var CONVERSATIONS_FETCH_URL_PATH = REQUEST_PREFIX_PATH + "widget/get-conversations/" + VISITOR_ID;
export var CHAT_PREFS_FETCH_URL_PATH = REQUEST_PREFIX_PATH + "widget/chat-prefs";
export var DELETE_CALENDAR_EVENT = REQUEST_PREFIX_PATH + "widget/calendar-event/delete";
export var CHAT_PREFS_VALIDATE_CAN_SHOW_WIDGET = REQUEST_PREFIX_PATH + "widget/can-show-chat-widget";
export var WEB_RULES_FETCH_URL_PATH = REQUEST_PREFIX_PATH + "widget/web-rules";
// export const TYPING_ALERT_URL_PATH =
//   REQUEST_PREFIX_PATH + "widget/typing-alerts/VISITOR";
export var TYPING_ALERT_URL_PATH = "https://eb-webhooks.engagebay.com/" + "widget/typing-alerts/VISITOR";
export var FILE_UPLOAD_URL_PATH = REQUEST_PREFIX_PATH + "panel/contentbox/repo/getFilePath";
export var GET_BIG_TEXT_URL_PATH = REQUEST_PREFIX_PATH + "widget/get-big-text/";
export var WINDOW_OPEN = "window-open";
export var OPENED_CHAT = "opened-chat";
export var OPENED_FLOW = "opened-flow";
export var CUSTOMER = "customer";
export var EXECUTE_FLOW_NODE_URL_PATH = REQUEST_PREFIX_PATH + "widget/flow/execute";
export var EXECUTION_LIST_FETCH_URL_PATH = REQUEST_PREFIX_PATH + "widget/flow/execution/";
export var START_FLOW_URL_PATH = REQUEST_PREFIX_PATH + "widget/flow/start";
export var VISITOR_UUID = window.VISITOR_ID;
export var OPERATORS = "operators";
export var WIDGET_ACTIVE_TAB = "widget_active_tab";
export var PROACTIVE_MESSAGE = "proactive-message";
export var FORM_DATA = "form_data";
export var FORM_DATA_ARRAY = "form_data_array";
export var TICKET_ACTIVE_ID = "ticket_active_id";
export var TICKET_ACTIVE_COMPONENT = "ticket_active_component";
export var HC_ACTIVE_ID = "hc_active_id";
export var HC_SEARCH_TEXT = "hc_search_text";
export var HC_ACTIVE_COMPONENT = "hc_active_component";
export var DEFAULT_BOT_ICON = "https://d2p078bqz5urf7.cloudfront.net/cloud/assets/img/chatbot-default-icon.png";
export var IS_NEW_SESSION = (function () {
    // console.log("Checkingup the session");
    var isNew = getSessionStoragePrefs("chat-session-loaded") ? false : true;
    if (isNew) {
        setSessionStoragePrefs("chat-session-loaded", true, 7);
    }
    // alert(isNew);
    return isNew;
    // return false;
})();
